import { render, staticRenderFns } from "./reservation-preview.vue?vue&type=template&id=161f5f38&scoped=true&"
import script from "./reservation-preview.vue?vue&type=script&lang=js&"
export * from "./reservation-preview.vue?vue&type=script&lang=js&"
import style0 from "./reservation-preview.vue?vue&type=style&index=0&id=161f5f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f5f38",
  null
  
)

export default component.exports